module.exports = __webpack_public_path__ + "static/media/Ecuador.ab043751.png";